import useFetch from 'utils/hooks/useFetch'
import { ApiCheckIsAdmin } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function AuthService() {
    const { showFail } = useModal()

    const { fetch: apiCheckIsAdmin } = useFetch(ApiCheckIsAdmin)
 
    const fetchCheckIsAdmin = async (userId) => {
        const res = await apiCheckIsAdmin({
            data: {
                userId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchCheckIsAdmin,
        
    }
}